module.exports = __webpack_public_path__ + "public/images/PerfectGiftForKids.44a67042dd6f6b18f894ba9a518ac4a8.png";